<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
  name: 'BarChart',
  props: ['series', 'options'],
  components: {
    highcharts: Chart,
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'column',
        },
        credits: {
          enabled: false,
        },
        series: this.series,
        ...this.options,
      };
    },
  },
};
</script>
